import { IndicatorName } from './fact';

export const ECOSYSTEM_CLASSIFICATION = {
  IUCN_GET: 'iucn_get',
  RESOLVE: 'resolve',
  IUCN_HABITATS: 'iucn_habitats',
} as const;

export const ECOSYSTEM_CLASSIFICATION_FACTS_BY_LEVEL = {
  [ECOSYSTEM_CLASSIFICATION.IUCN_GET]: {
    firstScalarFact: IndicatorName.iucn_get_level_1_realm_area,
    secondScalarFact: IndicatorName.iucn_get_level_2_biome_area,
    graphFact: IndicatorName.iucn_get_level_3_efg_area,
  },
  [ECOSYSTEM_CLASSIFICATION.RESOLVE]: {
    firstScalarFact: IndicatorName.resolve_level_1_biome_area,
    graphFact: IndicatorName.resolve_level_2_ecoregion_area,
    secondScalarFact: null,
  },
  [ECOSYSTEM_CLASSIFICATION.IUCN_HABITATS]: {
    firstScalarFact: IndicatorName.iucn_habitats_level_1_area,
    graphFact: IndicatorName.iucn_habitats_level_2_area,
    secondScalarFact: null,
  },
};

export type EcosystemClassificationType = (typeof ECOSYSTEM_CLASSIFICATION)[keyof typeof ECOSYSTEM_CLASSIFICATION];
